import axios from 'axios';
import { ENDPOINTS } from '@/config/endpoints';


class AuthService {
  constructor() {
    this.api = axios.create({
      baseURL: ENDPOINTS.SIGNUP_API,
      headers: {
        'accept': 'application/json, text/plain, */*',
        'content-type': 'application/json',
      }
    });
  }

  // Send OTP to user's email/mobile
  async sendOTP(data) {
    try {
      const response = await this.api.post('/onboard/user/send-otp', {
        countryCode: data.countryCode || '+91',
        countryName: data.countryName || 'India',
        indiaEmail: data.email,
        notIndiaEmail: null,
        indiaMobileNumberCtrl: data.mobileNumber,
        notIndiaMobileNumberCtrl: null
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Verify OTP
  async verifyOTP(data) {
    try {
      const response = await this.api.post('/onboard/user/credlix-verify-otp', {
        requestId: data.requestId,
        otp: data.otp,
        phoneNumber: data.phoneNumber,
        email: data.email,
        countryCode: data.countryCode || '+91',
        countryName: data.countryName || 'India',
        purpose: 'Credlix Business'
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Fetch supplier token
  async fetchSupplierToken(email, isFirstTime = true) {
    try {
      const response = await this.api.post(`/onboard/user/fetch-supplier-token?email=${email}&isFirstTime=${isFirstTime}`, {},
        // headers: {
        //   'origin': 'https://uat.credlixlab.com',
        //   'referer': 'https://uat.credlixlab.com/'
        // }
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Reset password
  async resetPassword(token, password) {
    try {
        const response = await this.api.post(`${ENDPOINTS.RESET_PASSWORD_API}/verify-reset-password`, {
        token,
        password
      },);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Save basic details
  async saveBasicDetails(data) {
    try {
      const response = await this.api.post('/onboard/user/credlix-basic-details', {
        name: data.name,
        fundRequirement: data.fundRequirement,
        tenor: data.tenor,
        purpose: data.purpose,
        iecCode: data.iecCode,
        id: data.id
      }, );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

// ✅ Login API
async loginDetails(email, password, recaptchaToken) {
  try {
    const response = await axios.post(
      `${ENDPOINTS.RESET_PASSWORD_API}/signin`,
      {
        email,
        password,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'g-recaptcha-response': recaptchaToken,
          'accept': 'application/json, text/plain, */*',
        },
      }
    );

    return response.data;
  } catch (error) {
    throw this.handleError(error);
  }
}


  // ✅ Forgot Password API
  async forgotPassword(email) {
    try {
      const response = await axios.post(`${ENDPOINTS.RESET_PASSWORD_API}/forgot-password`,
        { email },
        {
          headers: {
            'accept': 'application/json, text/plain, */*',
            'content-type': 'application/json',
          },
        }
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // ✅ Get User Profile
async getUserProfile(token) {
  try {
    const response = await axios.get(`${ENDPOINTS.RESET_PASSWORD_API}/v2/profile`,
      {
        headers: {
          'accept': 'application/json',
          'authorization': `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    throw this.handleError(error);
  }
}

  // Logout - invalidate session on server
  async logout(token) {
    try {
      const response = await axios.post(
        `${ENDPOINTS.RESET_PASSWORD_API}/logout`,
        {},
        {
          headers: {
            'accept': '*/*',
            'content-type': 'application/json',
            'authorization': `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Handle API errors
  handleError(error) {
    if (error.response) {
      // Server responded with error status
      return {
        message: error.response.data?.message || 'An error occurred',
        status: error.response.status,
        data: error.response.data
      };
    } else if (error.request) {
      // Request was made but no response received
      return {
        message: 'Network error. Please check your connection.',
        status: 0
      };
    } else {
      // Something else happened
      return {
        message: error.message || 'An unexpected error occurred',
        status: 0
      };
    }
  }
}

export default new AuthService();
